import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import M from 'materialize-css';
import { Link } from 'react-router-dom';
import { UserContext } from '../../UserContext';
import { checkPermiso } from '../../Utils/PermissionsFunctions';
import NoPermissions from '../NoPermissions/NoPermissions';
import Loader from '../../Layout/Loaders/Loader';
import VisitaFormulario from '../Doctores/VisitaFormulario';

const today = new Date();
const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
const firstDayMonth = startOfMonth.toISOString().split('T')[0];
const lastDayMonth = endOfMonth.toISOString().split('T')[0];

const VisitasTable = () => {
    const {user} = useContext(UserContext);
    const [rango,setRango] = useState({start:firstDayMonth,end:lastDayMonth});
    const [visitas,setVisitas] = useState([]);
    const [doctorId,setDoctorId] = useState();
    const [newVisita,setNewVisita] = useState(false);
    const [loaded,setLoaded] = useState(false);
    const [empleados,setEmpleados] = useState([]);
    const [filtros,setFiltros ] = useState({start:null,end:null,representante:'',doctor:''});
    const [sortBy, setSortBy] = useState({
        field:"",
        sortBy:"ASC"
    });
    const [permisos,setPermisos] = useState({
        visits_read:null,
        visits_update:null,
        visits_delete:null
    })

    useEffect(()=>{
        _getEmpleados();
        //inicializar modales
        var elemsFiltros = document.querySelector('#filtrosvisitas');   
        var elems = document.querySelector('#visitaNewModal');
        M.Modal.init(elemsFiltros, {dismissible: true});
        M.Modal.init(elems, {dismissible: false});
        getDoctoresAutocomplete();
    },[]);

    useEffect(()=>{
       // setLoaded(false);
        if(user.id){
            //si permisos ya fueron seteados no es necesario volver a setearlos
            setPermisos((prevPermisos) => ({
                ...prevPermisos,
                visits_read:checkPermiso("visits_read",user.permissions),
                visits_update:checkPermiso("visits_update",user.permissions),
                visits_delete:checkPermiso("visits_delete",user.permissions)
            }));

            getVisitasRango(rango);
        }
    },[user, rango]);

    useEffect(()=>{
        (permisos.visits_read !== null) && setLoaded(true);
    },[permisos]);
    
    const getVisitasRango = (range) =>{
        axios.post('api/visits_range',range).then(resp=>{
            console.log("Visitas rango",resp);
            if(resp.status === 200 && resp.data.length > 0){
                let visitasTemp = resp.data;
                // Filtrado optimizado usando reduce
                let visitasFiltradas = visitasTemp.filter(visit => {
                    let match = true;
                    if (filtros.representante) {
                        match = match && visit.representante === filtros.representante;
                    }
                    if (filtros.doctor) {
                        let tempArray = filtros.doctor.split(".- ");
                        if (tempArray.length > 0) {
                            let doctor_id = parseInt(tempArray[0]);
                            match = match && visit.doctor_id === doctor_id;
                        }
                    }
                    return match;
                });
                console.log("Visitas filtradas",visitasFiltradas);
                setVisitas(visitasFiltradas);
            }   
           
        }).catch(e=>console.log(e));
    }

    const _handleSort = (field) =>{
        if(field !== sortBy.field){
            setSortBy({...sortBy,field:field,sortBy:"DESC"});
        }else{
            setSortBy({...sortBy,sortBy:sortBy.sortBy === "DESC"?"ASC":"DESC"})
        }
    }
    useEffect(()=>{
        _ordenarTabla();
     // eslint-disable-next-line react-hooks/exhaustive-deps
     },[sortBy])
 
     const _ordenarTabla = () => {
         //se crea una copia de visitas para que la funcion de sort no modifique el array original
         let ordenados = visitas.slice(0);
       
         if(!sortBy.field.includes(".")){
            if(sortBy.sortBy === "ASC"){
                ordenados.sort((a,b)=>{
                    if (a[sortBy.field] > b[sortBy.field]) {
                        return 1;
                      }
                      if (a[sortBy.field] < b[sortBy.field]) {
                        return -1;
                      }
                      return 0;
                })
            }else{
                ordenados.sort((a,b)=>{
                    if (a[sortBy.field] < b[sortBy.field]) {
                        return 1;
                      }
                      if (a[sortBy.field] > b[sortBy.field]) {
                        return -1;
                      }
                      return 0;
                })
            }
         }else{
         //Caso con objetos anidados
           let arrayField = sortBy.field.split(".");
                if(sortBy.sortBy === "ASC"){
                    ordenados.sort((a,b)=>{
                        if (a[arrayField[0]][arrayField[1]] > b[arrayField[0]][arrayField[1]]) {
                            return 1;
                        }
                        if (a[arrayField[0]][arrayField[1]] < b[arrayField[0]][arrayField[1]]) {
                            return -1;
                        }
                        return 0;
                    })
                }else{
                    ordenados.sort((a,b)=>{
                        if (a[arrayField[0]][arrayField[1]] < b[arrayField[0]][arrayField[1]]) {
                            return 1;
                        }
                        if (a[arrayField[0]][arrayField[1]] > b[arrayField[0]][arrayField[1]]) {
                            return -1;
                        }
                        return 0;
                    })
                }
         }
      
         setVisitas(ordenados)
    }
    
    const _getEmpleados = () =>{
        axios.get('api/employees').then((resp)=>{
            setEmpleados(resp.data);
        }).catch(e=>console.log("Error:",e))
    }

    const getDoctoresAutocomplete = () => {
        axios.get('/api/doctors').then(res=>{
            var doctorsArray = res.data;
            var dataDoctor = {};
            for (var i = 0; i < doctorsArray.length; i++) {
                dataDoctor[doctorsArray[i].id +".- " + doctorsArray[i].nombre+" "+doctorsArray[i].apellidos] = null; 
            }
            M.Autocomplete.init(document.querySelector('#autocomplete-doctors'), {
                data: dataDoctor,
                minLength:0, 
                limit:10,
                onAutocomplete:handleDoctor
            });
            M.Autocomplete.init(document.querySelector('#autocomplete-input'), {
                data: dataDoctor,
                minLength:0,
                limit:10,
                onAutocomplete:(value)=>setFiltros(prevFiltros => ({ ...prevFiltros, doctor: value }))
            });
        }).catch(e=>console.log("Error",e));
    }

    const handleDoctor = (value) =>{
        let tempArray = value.split(".- ");
        if(tempArray.length > 0){
            let intId =  parseInt(tempArray[0]);
            setDoctorId(intId)
        }else{
            setDoctorId(null)
        }
    }

    const _aplicarFiltros = () =>{
        console.log("Filtros",filtros);
        console.log("Visitas",visitas);
        if(filtros.start && filtros.end){
            setRango({start:filtros.start,end:filtros.end});
        }else{
            setRango({start:firstDayMonth,end:lastDayMonth});
        }
    }

    const _limpiarFiltros = () =>{
        console.log("Limpiar filtros");
        setFiltros({start:'',end:'',representante:'',doctor:''});
        setRango({start:firstDayMonth,end:lastDayMonth});
        //limpiar autocomplete
        let instanceAutoInput = M.Autocomplete.getInstance(document.querySelector('#autocomplete-input'));
        instanceAutoInput.el.value = "";
        instanceAutoInput.close();
        M.Modal.getInstance(document.querySelector('#filtrosvisitas')).close();
    }

    const deleteVisita = (id) =>{
        if(window.confirm("¿Estas seguro de eliminar esta visita?, esta acción no se puede deshacer!")){
             axios.delete(`api/visits/${id}`).then(resp=>{
                console.log("Respuesta de eliminar visita",resp);
                if(resp.status === 200){
                    //retiramos la visita eliminada del array de visitas
                    setVisitas(visitas.filter(visit=>visit.id !== id));
                    M.toast({
                        html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Visita eliminada correctamente</span>',
                        classes:"success-notify"
                    });        
                }
            }).catch(e=>console.log("Error:",e));
        }   
    }   

    const visitaNewModalClose = () =>{
        console.log("cerrado..");
        let instanceAuto = M.Autocomplete.getInstance(document.querySelector('#autocomplete-doctors'));
        instanceAuto.el.value = "";
        instanceAuto.close();
        setDoctorId(0); 
        let instance = M.Modal.getInstance(document.querySelector('#visitaNewModal'));
        instance.close();
    }

    useEffect(()=>{
        if(newVisita){
            let instance = M.Modal.getInstance(document.querySelector('#visitaNewModal'));
            instance.close();
            setNewVisita(false);
            getVisitasRango(rango);
            //notificacion
            M.toast({
                html:'<i className="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Visita Agendada Correctamente</span>',
                classes:"success-notify"
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[newVisita, rango]);
    
    return (
        <div>
            {/**VISITAS MODAL **/}
            <div id="visitaNewModal" className="modal">
                <div className="modal-content m-p-0">
                    <div className='close-btn' onClick={visitaNewModalClose}>
                        <i className="material-icons">close</i>
                    </div>
                    
                    <div className='row m-p-0'>
                        <div className='col s12 p-20'>
                            <div className='input-field m-10'>
                                <label htmlFor="autocomplete-doctors">Doctor</label>
                                <input type="text" id="autocomplete-doctors" autoComplete="off" className="autocomplete" 
                                style={{border:'solid 1px #dee2e6',borderRadius:'4px', padding:'0 0 0 6px'}}/>
                            </div>
                        </div>
                        {doctorId > 0 ?
                            <div className='col s12 row'>
                                <VisitaFormulario
                                doctorId={doctorId} doctor_offices={[]} setNewVisita={setNewVisita}/>
                                <button  id='botonInmovil'
                                onClick={(e)=>visitaNewModalClose()}>
                                    <div className='col s10 m10 m-p-0' style={{fontSize: '14px', cursor:'pointer' }}> &nbsp;Cancelar</div>
                                </button>
                            </div>
                            :
                            <div className='col s11 centrar height-200'> 
                                <div className='col notification-info'>
                                    <p>Selecciona un doctor para agendar una visita!</p>
                                </div>
                            </div> 
                        }
                      
                    </div>
                    {doctorId > 0 ?
                    <div style={{display:'none', height:'1px'}}>.</div>
                    :
                    <div className="modal-footer m-0 p-12">
                        <div className=" m-10">
                            <button className="btn-blanco waves-effect waves-light row" style={{padding:'4px 8px!important'}} onClick={(e)=>visitaNewModalClose()}>
                                <div className='col s10 m10 m-p-0' style={{fontSize: '14px', cursor:'pointer' }}> &nbsp;Cancelar</div>
                            </button>
                        </div>
                    </div>}
                </div>
                
            </div> 
            {/**FILTOS MODAL **/}
            <div id="filtrosvisitas" className="modal">
                <div className="modal-content m-p-0 p-10">
                    <div className='close-btn modal-close'>
                        <i className="material-icons">close</i>
                    </div>
                    <div className='row modal-content m-p-0'>
                        <div className="row col s3 m12 p-5">
                            <div className="col s3 m1 m-p-0">
                                <img className='dentometric' src='/images/filter1.png' height={40} alt='filtros empleados'/>
                            </div>
                            <div className="col s3 m10 m-p-0 t-left"><h5 className='t-left'>Filtros</h5></div>
                        </div>
                      
                        <div className='row col s12 p-20'>

                            <div className="col s12 m6 m-t-10 input-text">
                                <label htmlFor="inicio">Desde</label>
                                <input id="inicio" type="date" value={filtros.start} onChange={(e)=>setFiltros({...filtros,start:e.target.value})}/>
                            </div>

                            <div className="col s12 m6 m-t-10 input-text">
                                <label htmlFor="fin">Hasta</label>
                                <input id="fin" type="date"  value={filtros.end}  onChange={(e)=>setFiltros({...filtros,end:e.target.value})}/>
                            </div>

                            <div className='col s12 m12 m-t-10'>
                                <label>Filtrar por representante</label>
                                <select className='browser-default' value={filtros.representante} onChange={(e)=>setFiltros({...filtros,representante:e.target.value})}>
                                    <option value="" disabled>Filtrar por Representante</option>
                                    {empleados.map((item) =>
                                        <option value={`${item.nombre} ${item.apellidos}`}  key={item.id}>{item.nombre} {item.apellidos}</option>
                                    )}
                                </select>
                            </div>
                            <div className='col s12 m12  m-t-10'>
                                <label>Filtrar por doctor</label>
                                <div className='input-field m-p-0'>
                                    <input type="text" id="autocomplete-input" className="autocomplete" autoComplete="off"/>
                                </div> 
                    
                            </div> 
                        </div>  
                             
                    </div>
               
                    <div className="modal-footer row m-p-0">
                        <div className="col s6 m8"></div>
                        <div className="col s3 m2">
                            <button className="btn-blanco waves-effect waves-light row"
                            style={{padding:'4px 8px!important',}}
                            onClick={(e)=>console.log()}
                            >
                                <div className='col s2 m2 m-p-0 centrar'>
                                    <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/clear-filters.png' alt='doctor dento metric' style={{width:'20px',}} />
                                </div>    
                                <div className='col s10 m10 m-p-0  modal-close' style={{fontSize: '14px', cursor:'pointer' }} onClick={(e)=>_limpiarFiltros()}> &nbsp;Limpiar</div>
                            </button>
                        </div>
                        <div className="col s3 m2">
                            <button className="btn-blanco waves-effect waves-light row modal-close"
                            style={{padding:'4px 8px!important',}}
                            onClick={(e)=>_aplicarFiltros()}
                            >
                                <div className='col s2 m2 m-p-0 centrar'>
                                    <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/filter1.png' alt='doctor dento metric' style={{width:'20px',}} />
                                </div>    
                                <div className='col s10 m10 m-p-0' style={{fontSize: '14px', cursor:'pointer' }}> &nbsp;Filtrar</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/** FIN FILTOS MODAL **/}
            <div className='container-admin-menu'>
                {/** FIN FILTOS MODAL <Breadcrumb hasButton={true} hasFilters={false} /> **/} 
                 <div className='row col s12 m-0 p-0-15 centrar-h'>
                    <div className='col s12 m10 p-0-10'> <Breadcrumb hasButton={false} hasFilters={false} /> </div>
                    <div className='col s12 m2'>
                        <button className="btn-blanco row modal-trigger" data-target="visitaNewModal" type="submit" name="action">
                            <div className='col s2 m2 m-p-0 centrar'>
                                <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/calendar.png' alt='doctor dento metric' style={{width:'20px',}} />
                            </div>    
                            <div className='col s10 m10 m-p-0' style={{fontSize: '14px', cursor:'pointer' }}>&nbsp;Nueva Visita</div>
                        </button>
                    </div>
                </div>
            </div>
            <div className='container-admin-container'> 
                <div className='container-admin z-depth-1 row'>
                    {loaded ?
                        <>
                            <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h'>
                                <div className='col s12 m9'>
                                    <h6><span>Visitas del Mes</span> | <span>Desde {startOfMonth.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })}</span>  hasta {endOfMonth.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })}</h6>
                                </div>
                                <div className="col s12 m3 t-right">
                                    <button className="btn-blanco row modal-trigger" data-target="filtrosvisitas" type="submit" name="action">
                                        <div className='col s2 m2 m-p-0 centrar'>
                                            <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/filter.png' alt='doctor dento metric' style={{width:'20px',}} />
                                        </div>    
                                        <div className='col s10 m10 m-p-0' style={{fontSize: '14px', cursor:'pointer' }}> + Filtros</div>
                                    </button>
                                </div>
                            </div>
                            {permisos.visits_read ?
                                <div className='m-p-0'>
                                    <div>
                                        <div className='col table table-doc m-p-0' style={{width:'100%'}}>
                                            <div className='table-header row m-t-20 movil-oculto'>
                                                <div className='col s10 m2 centrar'> Doctor &nbsp; <i className="material-icons" onClick={(e)=>{_handleSort("doctor.apellidos")}}>unfold_more</i></div>
                                                <div className='col s10 m2 centrar'> Representante &nbsp; <i className="material-icons" onClick={(e)=>{_handleSort("representante")}}>unfold_more</i></div>
                                                <div className='col s10 m2 centrar'> Lugar / Horario</div>
                                                <div className='col s12 m1 centrar'> Fecha Visita <i className="material-icons" onClick={(e)=>{_handleSort("fecha_visita")}}>unfold_more</i></div>
                                                <div className='col s12 m1 centrar'> Hora <i className="material-icons" onClick={(e)=>{_handleSort("hora")}}>unfold_more</i></div>
                                                <div className='col s12 m1 centrar'> Causa</div>
                                                <div className='col s12 m2 centrar'> Observaciones</div>
                                                <div className='col s12 m1'> Acciones</div>
                                            </div>
                                            
                                            <div className='table-container'>
                                            {visitas.map((visita)=>
                                                <div className={Number(visita.completada) === 1 ? 'row centrar bg-success' : 'row centrar'} key={visita.id}>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> Nombre </div>
                                                    </div>
                                                    <div className='col s9 m2 t-centrado'>
                                                        <div className='centrado'>
                                                            {visita?.doctor.apellidos} {visita?.doctor.nombre}
                                                        </div>
                                                    </div>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> Representante </div>
                                                    </div>
                                                    <div className='col s9 m2 t-centrado'> 
                                                        <div className='centrado'>{visita.representante}</div>
                                                    </div>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> direccion </div>
                                                    </div>
                                                    <div className='col s9 m2 t-centrado'> 
                                                        <div className='centrado'>{visita.direccion} </div>
                                                    </div>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> Fecha </div>
                                                    </div>
                                                    <div className='col s9 m1 centrar row '>
                                                        <div className='centrado'>{visita.fecha_visita}</div>
                                                    </div>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> Hora </div>
                                                    </div>
                                                    <div className='col s9 m1 t-centrado'> 
                                                        <div className='centrado'>{visita.hora}</div>
                                                    </div>
                                                    <div className='col s3 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> Causa </div>
                                                    </div>
                                                    <div className='col s9 m1 t-centrado'> 
                                                        <div className='centrado'>
                                                            {visita.causa_visita}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m4 movil-visible' style={{border:'solid 1px #fff'}}>
                                                        <div className='table-header-movil'> observaciones </div>
                                                    </div>
                                                    <div className='col s12 m2 t-centrado'> 
                                                        <div className='centrado'>{(visita.observaciones || '').slice(0,25)} ...</div>
                                                    </div>
                                                    <div className='col s12 m1 movil-oculto'>
                                                        <div className='row centrar cont-textos'>
                                                        {permisos.visits_update && visita.completada != 1 &&
                                                            <Link to={`../visitas/new/${visita.doctor_id}`} style={{color:'green', border:'solid blue 2px'}}
                                                            data-position="top"
                                                            data-tooltip="Editar"
                                                            data-target="visitaNewModal" type="submit" name="action"
                                                            className="col m6 m-p-0 centrar movil-100 tooltipped" >
                                                                <i className="material-icons m-p-0" style={{fontSize:'20px',}}>create</i>
                                                            </Link>
                                                        }
                                                            <Link to={`detail/${visita.id}`} 
                                                            data-position="top"
                                                            data-tooltip="Ver Detalle"
                                                            className="col m6 m-p-0 centrar movil-100 tooltipped" >
                                                                <i className="material-icons m-p-0" 
                                                                style={{fontSize:'20px',}}>content_paste</i>
                                                            </Link>
                                                            {permisos.visits_delete &&
                                                            <div className='col m6 m-p-0 centrar movil-100' onClick={(e)=>deleteVisita(visita.id)}>
                                                                <i className="material-icons m-p-0" style={{fontSize:'20px',color:'red',cursor:'pointer'}} >delete_forever</i>
                                                            </div>
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            </div>    
                                            
                                        </div>
                                    </div>
                                </div>
                                :
                                <NoPermissions />
                            } 
                        </>
                        :
                        <Loader />
                    }
                </div>
            </div>
        </div>
    );
};

export default VisitasTable;